module.exports = __webpack_public_path__ + "img/scene-coordinator.6dffae1c.svg";